var map = {
	"./add-big.svg": "0d9a",
	"./add.svg": "876b",
	"./approved.svg": "6ee3",
	"./arrow-forward.svg": "f76a",
	"./arrow-right.svg": "1d68",
	"./arrow-up-new.svg": "93c2",
	"./arrow-up-v2.svg": "1373",
	"./arrow-up.svg": "a4f5",
	"./attach.svg": "4b32",
	"./banner-upload.svg": "d709",
	"./calendar-empty.svg": "6fdb",
	"./calendar.svg": "6bca",
	"./calendar_clock.svg": "0e4e",
	"./calendar_clock_medium.svg": "e0b1",
	"./camera.svg": "d24a",
	"./cancel-file-upload.svg": "35fa",
	"./caret-down.svg": "26de",
	"./cc-inbox.svg": "14a1",
	"./check-circle-blue.svg": "182a",
	"./check-circle-fill-green.svg": "319f",
	"./check-circle-orange.svg": "7341",
	"./chevron-right.svg": "5046",
	"./clear-calendar.svg": "0886",
	"./close-img.svg": "fe79",
	"./close.svg": "0572",
	"./collapse.svg": "38357",
	"./colorpicker.svg": "9560",
	"./comment-info.svg": "622d",
	"./confirm.svg": "0873",
	"./copy.svg": "fd74",
	"./credit_card.svg": "2c0a",
	"./crop-download.svg": "4910",
	"./currency.svg": "4068",
	"./default-tooltip.svg": "eb85",
	"./delete-red.svg": "3c08",
	"./discount-coupon.svg": "161f",
	"./down-chevron.svg": "263e",
	"./download-blue.svg": "3095",
	"./download.svg": "0339",
	"./dropdown.svg": "2f2d",
	"./duplicate.svg": "fcf4",
	"./edit.svg": "c560",
	"./ellipsis-vertical.svg": "d863",
	"./ellipsis.svg": "9ff6",
	"./exclamation-point-fill-yellow.svg": "5ebb",
	"./expand-more.svg": "e1b8",
	"./expand.svg": "c2c1",
	"./export.svg": "fd49",
	"./filter_alt.svg": "d2cd",
	"./garbage-can.svg": "5e47",
	"./gear-black.svg": "d52f",
	"./gear-branch.svg": "0bdd",
	"./gear-orange-branch.svg": "48bc",
	"./gear.svg": "5197",
	"./ic-add-hover.svg": "efe8",
	"./ic-add.svg": "d9cb",
	"./ic-cart.svg": "325f",
	"./ic-folder.svg": "497e",
	"./ic-pin-map.svg": "5ba3",
	"./ic-pin.svg": "b02d",
	"./ic-upload-file.svg": "aa93",
	"./image-icon.svg": "7a9a",
	"./import.svg": "7bc2",
	"./info-circle.svg": "8341",
	"./info-fill-blue.svg": "088a",
	"./info.svg": "3e95",
	"./key-account-approve.svg": "5700",
	"./key-account-reject.svg": "35f1",
	"./key-account-update.svg": "5a88",
	"./left-arrow.svg": "f5cd",
	"./link.svg": "7262",
	"./location.svg": "c411",
	"./logout-white.svg": "2019",
	"./magnifying-glass.svg": "7112",
	"./message-circle.svg": "388b",
	"./notif-email.svg": "1c7a",
	"./notif-in-app-message.svg": "4691",
	"./notif-sms.svg": "d081",
	"./open-eye.svg": "49a3",
	"./panorama.svg": "9b71",
	"./pencil.svg": "7576",
	"./peso.svg": "081b",
	"./phone.svg": "a3f6",
	"./pile-file.svg": "9e5f",
	"./points.svg": "63cb",
	"./punch-card/delete.svg": "0769",
	"./punch-card/download.svg": "5185",
	"./punch-card/duration.svg": "33cc",
	"./punch-card/edit.svg": "71e5",
	"./punch-card/members.svg": "9342",
	"./punch-card/print.svg": "b926",
	"./punch-card/stamps/coffee.svg": "2c84",
	"./punch-card/stamps/croissant.svg": "d31e",
	"./punch-card/stamps/donut.svg": "eb61",
	"./punch-card/stamps/drumstick.svg": "8877",
	"./punch-card/stamps/egg.svg": "650e",
	"./punch-card/stamps/ellipse.svg": "198b",
	"./punch-card/stamps/pizza.svg": "9dd8",
	"./punch-card/stamps/popcorn.svg": "53dc",
	"./punch-card/stamps/upload.svg": "f2af",
	"./punch-card/view.svg": "caa5",
	"./remove.svg": "8010",
	"./rewards.svg": "46d3",
	"./right-arrow.svg": "432e",
	"./right-chevron.svg": "5055",
	"./send-message.svg": "d3d6",
	"./settings.svg": "e15e",
	"./share.svg": "40cf",
	"./shopping-cart.svg": "3ab1",
	"./sms.svg": "f35f",
	"./sort-down.svg": "fcf8",
	"./sort-up.svg": "8630",
	"./sort.svg": "3bc7",
	"./storefront.svg": "d08e",
	"./swap_vert.svg": "f251",
	"./text-bold-active.svg": "1151",
	"./text-bold.svg": "4800",
	"./text-center-active.svg": "6def",
	"./text-center.svg": "a43e",
	"./text-italic-active.svg": "bb14",
	"./text-italic.svg": "9715",
	"./text-left-active.svg": "b124",
	"./text-left.svg": "6c0f",
	"./text-right-active.svg": "29cd",
	"./text-right.svg": "bdb4",
	"./text-underline-active.svg": "d021",
	"./text-underline.svg": "72fd",
	"./three-dots.svg": "8499",
	"./time.svg": "e86f",
	"./tooltip-hover.svg": "d924",
	"./tooltip.svg": "6f61",
	"./transactions.svg": "9762",
	"./trash-bin.svg": "7dc1",
	"./upload-folder-blue.svg": "99cf",
	"./upload.svg": "a13b",
	"./wallet.svg": "1113",
	"./web.svg": "8563",
	"./white-check-thin.svg": "d4d5",
	"./white-check.svg": "e511",
	"./x-circle-fill-red.svg": "eadf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";